/* eslint-disable no-underscore-dangle */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useCallback, useState } from "react";
import { ReportGmailerrorred, Clear } from "@mui/icons-material";
import axios from "axios";
import { Loader } from "../../components/Loader";
import { getHeaders } from "../../api/headers";

export type TPropertyActionStatus = "PAUSED_BY_APPLICATION" | "ACTIVE";

interface IPropertyActionDialogProps {
  rowsSelected: readonly { code: number; id: string }[];
  newStatus: TPropertyActionStatus;
  onClose(): void;
  onSuccess(): void;
}

export function PropertyActionDialog({
  rowsSelected,
  newStatus,
  onClose,
  onSuccess,
}: IPropertyActionDialogProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const onSubmit = useCallback(async () => {
    setIsLoading(true);

    try {
      const headers = await getHeaders();

      await axios.put(
        `${process.env.REACT_APP_API_URL}/v1/advertisements/status`,
        {
          advertisements: rowsSelected.map((item) => ({
            id: item.id,
          })),
          status: newStatus,
        },
        headers,
      );

      setIsLoading(false);
      onSuccess();
    } catch (err: any) {
      setError(err?.response?.data?.error.toString());
    }
  }, [newStatus, onSuccess, rowsSelected]);

  return (
    <Dialog
      open
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      fullScreen={fullScreen}
    >
      {isLoading && <Loader />}

      <DialogTitle id="alert-dialog-title">
        <div className="flex items-center">
          {newStatus === "ACTIVE"
            ? "Confirmar Aprobación"
            : "Confirmar Rechazo"}
        </div>
      </DialogTitle>

      <IconButton className="!absolute right-3 top-3" onClick={onClose}>
        <Clear className="text-secondary" />
      </IconButton>

      <DialogContent dividers>
        <div className="w-full flex flex-col gap-4">
          {error && (
            <Alert
              icon={<ReportGmailerrorred fontSize="inherit" />}
              severity="error"
            >
              {error}
            </Alert>
          )}

          <p>
            {newStatus === "ACTIVE"
              ? "Estás a punto de aprobar la(s) publicación(es). Una vez aprobada(s), se mostrará(n) a todos los usuarios. ¿Deseas continuar?"
              : "Estás a punto de rechazar la(s) publicación(es). Esta acción es permanente, y la(s) publicación(es) no se mostrará(n) a los usuarios. ¿Deseas continuar?"}
          </p>

          <p>
            Cód: <br />
            {rowsSelected.map((item) => item.code).join(", ")}
          </p>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="text" color="secondary">
          Cancelar
        </Button>

        <Button onClick={onSubmit} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
